<template>
    <div class="field">
        <label v-if=label class="field__label">{{ label }}</label>

        <select class="field__input" ref="field" required @input="handleInput">
            <option v-if="defaultText" value="">{{ defaultText }}</option>
            <option v-for="(option, index) in options" :key="index" :value="option">
                {{ option }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "SelectField",
    props: {
        value: String,
        label: String,
        defaultText: String,
        placeholder: String,
        type: {
            type: String,
            default: 'text'
        },
        options: Array
    },
    methods: {
        getValue() {
            return this.$refs.field.value;
        },
        handleInput() {
            this.$emit('input', this.getValue())
        }
    }
}
</script>

<style scoped>

</style>